<template>
	<div class="flex-column">
		<div class="full-height overflow-y-auto pb-50 mb-10">
			<div>
				<label class="h6 display-block">
					업무명
					<input v-model="item.work_name" class="input-box radius-20 width-100 mt-10" placeholder="업무명을 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-10">
					작업 기간

					<div class="justify-space-between gap-10 items-center mt-10">
						<input v-model="item.sDate" class="input-box radius-20  flex-1" placeholder="시작일 입력하세요" maxlength="20" lang="ko" type="date"/>
						~
						<input v-model="item.eDate" class="input-box radius-20  flex-1" placeholder="종료일 입력하세요" maxlength="20" lang="ko" type="date"/>
					</div>
				</label>

				<label class="h6 display-block mt-10">
					업무내용
					<textarea
						v-model="item.work_content"
						class="input-box radius-20 width-100 mt-10"
						placeholder="업무내용을 입력하세요"
						lang="ko">
					</textarea>
				</label>
			</div>

			<div>

				<label class="h6 display-block mt-10">
					현장 관리 인원
				</label>

				<div>
					<ul>
						<template
							v-for="member in items_member"
						>
							<li
								:key="member.member_id"
								class="box radius-20 pa-10 mt-10 justify-space-between gap-10 items-center"
								:class="{'box-primary':member.status == '1'  }"
								@click="setStatus(member)"
							>
								{{ member.member_name }} ( {{ member.member_id }} )

								<button
									v-if="member.member_id != user.member_id"
								>
									<v-icon
										v-if="member.status == '1'"
										class="color-primary"
										large
									>mdi mdi-toggle-switch</v-icon>
									<v-icon
										v-else
										large
									>mdi mdi-toggle-switch-off</v-icon>
								</button>
							</li>
						</template>
					</ul>
				</div>
			</div>
		</div>
		<div
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="putProjectWork"
			>저장</button>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ProjectWorkDetail'
	, props: ['user']
	, data: function(){
		return {
			program: {
				name: '업무 상세 정보'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
			}
			, item: {

			}
			, work_idx: this.$route.params.idx
			, items_member: []
		}
	}
	, methods: {
		putProjectWork: async function(){
			this.$bus.$emit('on', true)
			try {

				this.$set(this.item, 'project_member', JSON.stringify(this.items_member))
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/putProjectWork'
					, data: this.item
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, getData: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'get'
					, url: 'project/getProjectWork'
					, data: {
						idx: this.work_idx
					}
				})

				if(result.success){
					this.item = result.data.work_info
					this.items_member = result.data.member_list
					this.$bus.$emit('notify', { type: 'success', message: result.message})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, setStatus: async function(member_info){
			if(member_info.member_id != this.user.member_id){
				this.$set(member_info, 'status', member_info.status == '1' ? member_info.status = '0' : member_info.status = '1')
			}

			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/putProjectWorkMemberStatus'
					, data: {
						idx: this.work_idx
						, member_id: member_info.member_id
						, status: member_info.status
					}
				})

				if(result.success){
					//
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
	}
	, created() {
		if(this.user.member_level < 3){
			this.$bus.$emit('to', {name: 'ProjectWorkView', params: { idx: this.work_idx}})
		}else{
			this.$bus.$emit('onLoad', this.program)
			this.getData()
		}
	}
}
</script>